const messages = {
  subtitle: "Meet Our Bridgestone team",
  title: "Contactos e Serviços",
  description:
    "Bem-vindo à Área de Assistência da BRIDGESTONE PLUS. Aqui podes encontrar os detalhes dos contactos da equipa de vendas.",
  teams: {
    direct: "Direct",
    indirect: "In Direct",
    tyre: "Equipa comércio de pneus",
    car: "Equipa concessionários",
    lkw: "Equipa camiões",
    em_otr: "Equipa EM/OTR",
    farm_tractor: "Equipa tratores agrícolas",
    bandag: "Equipa Bandag",
    subtitle: "Meet Our Bridgestone team",
  },
  contact: {
    index: {
      title: "",
      description: "",
    },
    categories: {
      service: {
        description: "",
      },
      touch: {
        title: "",
        description: "",
      },
      contact: {
        short_desc: "",
      },
    },
    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
